module.exports = __webpack_public_path__ + "media/Video 107.b9c79e72.mp4";